import React from 'react';
import { legendColorBoxBase } from '../../css/style';

const getLegendColorBoxStyle = color => ({
  ...legendColorBoxBase,
  background: color,
});

const LegendColorBox = ({ color }) => <div style={getLegendColorBoxStyle(color)} />;

export default LegendColorBox;
